<div [class]="color" id="avatar-container-menu" class="w-56 h-56 cursor-pointer">
  <h4 id="avatar-name-menu" class="text-center font-sans text-white text-h400">{{ avatarLetters }}</h4>
</div>
